import React from "react";
import { AppSize, pxToRem } from "@/util";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import Link from "next/link";

export default function Hero() {
  const { classes } = styles();

  return (
    <Box className={classes.container}>
      {/* Text Content */}
      <Box className={classes.detCont} id="who-we-are">
        <Typography className={classes.head}>Who we are</Typography>
        <Typography className={classes.desc}>
          AREL is a real estate development and investment company offering
          property listings, consultation services, and investment opportunities
          in premium residential and commercial properties across Nigeria.
        </Typography>
      </Box>

      <Box className={classes.detCont} >
        <Typography className={classes.head}>Information we collect</Typography>
        <Typography className={classes.desc}>
          We may collect the following types of personal information when you
          visit our website or engage with our services: consultations
        </Typography>
        <ul className={classes.list}>
          <li>Full Name</li>
          <li>Email Address</li>
          <li>Phone Number</li>
          <li>House Address</li>
        </ul>
      </Box>

      <Box className={classes.detCont} >
        <Typography className={classes.head}>
          How We Use Your Information
        </Typography>
        <Typography className={classes.desc}>
          We use your information to:{" "}
        </Typography>

        <ul className={classes.list}>
          <li> Process bookings and inquiries</li>
          <li> Provide real estate consultations and recommendations</li>
          <li> Send updates about properties, investments, or company news</li>
          <li> Respond to your questions or feedback</li>
          <li>
            Improve our services and website experience Comply with legal
            obligations
          </li>
        </ul>
      </Box>
      <Box className={classes.detCont} >
        <Typography className={classes.head}>
          Cookies and Tracking Technologies
        </Typography>
        <Typography className={classes.desc}>
          AREL’s website uses cookies to personalize your experience and collect
          data on usage patterns. You may choose to disable cookies in your
          browser settings; however, some features of our website may not
          function properly.
        </Typography>
      </Box>
      <Box className={classes.detCont} >
        <Typography className={classes.head}>
          Sharing Your Information
        </Typography>
        <Typography className={classes.desc}>
          We do not sell, rent, or trade your personal data. We may share your
          information with:
        </Typography>
        <ul className={classes.list}>
          <li>Authorized AREL team members or agents </li>
          <li>
            {" "}
            Trusted service providers who support our operations (e.g., hosting,
            payment processors)
          </li>
          <li>Legal authorities, when required by law</li>
        </ul>
      </Box>
      <Box className={classes.detCont}>
        <Typography className={classes.head}>Data Security</Typography>
        <Typography className={classes.desc}>
          We implement strong security protocols to protect your personal data,
          including encryption, access controls, and secure hosting. However, no
          online data transmission can be 100% secure.
        </Typography>
      </Box>
      <Box className={classes.detCont}>
        <Typography className={classes.head}>Your Rights</Typography>
        <Typography className={classes.desc}>You have the right to:</Typography>
        <ul className={classes.list}>
          <li>Access your personal data</li>
          <li>Request corrections to inaccurate data</li>
          <li>Request deletion of your data (where applicable)</li>
          <li>Opt-out of marketing communications at any time</li>
        </ul>
      </Box>
      <Box className={classes.detCont}>
        <Typography className={classes.head}>Third-Party Links</Typography>
        <Typography className={classes.desc}>
          Our website may contain links to third-party websites. AREL is not
          responsible for the privacy practices or content of those external
          sites.
        </Typography>
      </Box>
      <Box className={classes.detCont}>
        <Typography className={classes.head}>Children’s Privacy</Typography>
        <Typography className={classes.desc}>
          Our services are not directed at children under the age of 16, and we
          do not knowingly collect personal data from minors.
        </Typography>
      </Box>
      <Box className={classes.detCont} >
        <Typography className={classes.head}>Contact Us</Typography>
        <Typography className={classes.desc}>
          If you have any questions or concerns about this Privacy Policy,
          please contact:
        </Typography>
        <Box>
          <Typography className={classes.desc}>
            📍 AREL (Avvic Real Estate Limited)
          </Typography>
          <Typography className={classes.desc}>📞 +234 906 315 7836</Typography>
          <Typography className={classes.desc}>
            <Link
              href="https://www.arelhomesng.com"
              target="_blank"
              className={classes.link}
            >
              📧 info@arelhomesng.com
            </Link>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: theme.spacing(4),
    alignItems: "flex-start",
    padding: `20px ${pxToRem(AppSize.padding)}`,

    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(2)} ${pxToRem(20)}`,
    },
  },
  head: {
    fontWeight: 700,
    fontSize: pxToRem(38),
    color: "#323232",
    fontFamily: "Playfair Display",
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(27),
    },
  },
  desc: {
    fontWeight: 400,
    fontSize: pxToRem(20),
    color: "#6A6A6A",
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(18),
    },
  },
  alignment: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
  link: {
    color: "#1A35DF",
  },
  list: {
    fontWeight: 400,
    fontSize: pxToRem(20),
    color: "#6A6A6A",
    paddingLeft: pxToRem(22),
    listStyleType: "disc",
    "& li": {
      marginBottom: theme.spacing(1),
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(18),
    },
  },
  detCont: {},
}));
